<!-- Divider -->
<!-- <div
    class="fuse-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div> -->

<div class="ml-2 h-px bg-gray-700"></div>
